import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

// Custom Hook for animating numbers
const useAnimateNumber = (endValue, inView) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = endValue / (duration / 10);

      const interval = setInterval(() => {
        start += increment;
        if (start >= endValue) {
          clearInterval(interval);
          setValue(endValue);
        } else {
          setValue(Math.ceil(start));
        }
      }, 10);
    }
  }, [inView, endValue]);

  return value;
};

function Ribbon() {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <ul
        ref={ref}
        className="w-full bg-[#FF6F00] md:h-40 h-auto grid grid-cols-2 md:grid-cols-4 justify-center items-center text-center py-6 md:py-10 gap-4 md:gap-16 lg:gap-20"
      >
        {/* Years of Experience */}
        <div className="flex flex-col text-white gap-1 md:gap-3 items-center">
          <p className="text-3xl md:text-5xl font-bold">{useAnimateNumber(16, inView)}+</p>
          <h1 className="text-xs md:text-sm text-center">Years of Experience</h1>
        </div>

        {/* Happy Customers */}
        <div className="flex flex-col text-white gap-1 md:gap-3 items-center">
          <p className="text-3xl md:text-5xl font-bold">{useAnimateNumber(1000, inView)}+</p>
          <h1 className="text-xs md:text-sm text-center">Happy Customers</h1>
        </div>

        {/* Loan Approved */}
        <div className="flex flex-col text-white gap-1 md:gap-3 items-center">
          <p className="text-3xl md:text-5xl font-bold">{useAnimateNumber(10, inView)} Cr+</p>
          <h1 className="text-xs md:text-sm text-center">Loan Approved</h1>
        </div>

        {/* Working Staff */}
        <div className="flex flex-col text-white gap-1 md:gap-3 items-center">
          <p className="text-3xl md:text-5xl font-bold">{useAnimateNumber(50, inView)}+</p>
          <h1 className="text-xs md:text-sm text-center">Working Staff</h1>
        </div>
      </ul>

      <div className="flex flex-col md:flex-row items-center md:text-center p-6 md:p-14 w-full md:justify-between  m-10">
        <h3 className="text-black font-bold text-4xl md:text-6xl leading-tight text-left">
        Empowering Your <br className="hidden md:block" /> Financial Journeys.
        </h3>
        <p className="max-w-[600px] text-[#808080] text-lg md:text-xl font-medium leading-normal mt-6 md:mt-0">
          With years of expertise and a customer-centric approach, we strive to deliver innovative solutions that simplify and enhance your financial journey.
        </p>
      </div>
    </div>
  );
}

export default Ribbon;